import { MetrikaChartSection } from './MetrikaChartSection';

export const MetrikaActivityTab = () => (
  <>
    <MetrikaChartSection
      title="Количество заявок"
      endpoint="bids"
      yLabel="Количество заявок"
      extraFilters={['device', 'source']}
    />
    <MetrikaChartSection title="Обращения через формы" endpoint="appeals" yLabel="Обращений" />
  </>
);

export const MetrikaTrafficTab = () => (
  <>
    <MetrikaChartSection title="Общий трафик" endpoint="traffic" yLabel="Посещение" />
    <MetrikaChartSection
      title="Заявки от партнеров"
      endpoint="partnersTraffic"
      yLabel="Количество заявок"
      extraFilters={['partners']}
    />
  </>
);
